//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";


function RedemptionAPI() {
    const { state, dispatch } = useContext(Context)
    const { handleResponse, handleError } = HandleApiResponse();

    async function getRedemption(values) {
        try {
            const obj = {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
            let query;
            query = JSON.stringify(values)
            let res = await fetch(`${config.host}/cdr-panel/api/redemption?query=${query}`, obj)
            return handleResponse(res)
        } catch (error) {
            handleError(error)
        }
    }

    async function search(values) {
        try {
            const obj = {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
            let query;
            query = JSON.stringify(values)
            let res = await fetch(`${config.host}/cdr-panel/api/redemption/search?query=${query}`, obj)
            return handleResponse(res)
        } catch (error) {
            handleError(error)
        }
    }

    async function getReasonDescription() {
        try {
            const obj = {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
            let res = await fetch(`${config.host}/cdr-panel/api/redemption/reason-description`, obj)
            return handleResponse(res)
        } catch (error) {
            handleError(error)
        }
    }

    async function cancelRedemption(values) {
        try {
            const obj = {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values)
            }
            let res = await fetch(`${config.host}/cdr-panel/api/redemption/cancel-redemption`, obj)
            return handleResponse(res)
        } catch (error) {
            handleError(error)
        }
    }

    async function getRedemptionDetails(values) {
        try {
            const obj = {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
            let query;
            query = JSON.stringify(values)
            let res = await fetch(`${config.host}/cdr-panel/api/redemption/redemption-details?query=${query}`, obj)
            return handleResponse(res)
        } catch (error) {
            handleError(error)
        }
    }

    async function Export(values) {
        try {
          const obj = {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"          
            },
            body: JSON.stringify(values),
          };
          let res = await fetch(`${config.host}/cdr-panel/api/redemption/export`, obj);
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

    return {
        getRedemption,
        search,
        getReasonDescription,
        cancelRedemption,
        getRedemptionDetails,
        Export
    }
}

export default RedemptionAPI